/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import {
  Box,
  Button,
  Grid,
  Stack,
  Table,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  styled,
} from "@mui/material";
import { tableCellClasses } from "@mui/material/TableCell";

import { API } from "../../pages/backend";

import { toast } from "react-toastify";
import axios from "axios";
import Swal from "sweetalert2";
import domtoimage from "dom-to-image";
import PaymentModal from "../../paymentcomp/modal";
import { setTransactionDetails } from "../../store/reducers/transactionDetails";
import { showModal } from "../../store/reducers/modal";
import Receipt from "../../paymentcomp/paymentreceipt";
import { ToWords } from "to-words";
import ConfirmationReceipt from "../../paymentcomp/confirmationreceipt";
import FormButton from "../ui/button/FormButton";
import Spinner from "../ui/Spinner";
import styles from "./invoice.module.scss"

const Invoicedownload = ({  }) => {
const {id} = useParams()

  // const details = useSelector((state) => state.transactionDetails.data.transactionDetails);
  // console.log(invoiceDetails)
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const user = useSelector((state) => state.user.data.details);
  // console.log(user);
  const [invoiceLoading, setInvoiceLoading] = useState(false);
  const [codeLoading, setCodeLoading] = useState(false);
  const details = useSelector(
    (state) => state.bills.data.bills
  );

  const downloadDetails = details.find((item) => item.id === id )
 

  const goBack = () => {
    window.history.back()
  }
  console.log(downloadDetails)
  // console.log(details, 'Details')

  const [schoolName, setSchoolName] = useState('')

  useEffect(() => {
    if(downloadDetails.assessmentCode === '01') {
      setSchoolName('Screening Test Model College[NGN]')
    } else {
      setSchoolName('')
    }
  }, [])
  // console.log(details);
  // console.log(details?.price)
  const token = useSelector((state) => state.user.data.token);
  const [transactionDetails, setTransactionDetailss] = useState();
  const beceCodeUrl = `${API}auth/code/bece/`;
  const casCodeUrl = `${API}auth/code/cas/`;

  
  const toWords = new ToWords({
    localeCode: "en-NG",
  });

  const examCodeUrl =
    details.paymentExamType === "B.E.C.E" ? beceCodeUrl : casCodeUrl;

  const charge = 0.029 * details?.price;
  const totalAmount = parseInt(charge) + parseInt(details?.price);

  // const priceUpdateAddCharge = {
  //     payerName: `${user.firstName} ${user.lastName}`,
  //     productQuantity: details?.productQuantity,
  //     price: details?.price,
  //     unitPrice: details?.unitPrice,
  //     examType: details?.examType,
  //     paymentExamType: details?.paymentExamType,
  //     priceWithCharge: totalAmount,
  //     billNumber: details?.billNumber,
  //     address: details?.address,
  // }

  const generateCode = async () => {
    try {
      setCodeLoading(true);
      const body = {
        categoryId: user?.categoryId,
        schoolCode: user?.schoolCode,
        numOfCandidates: parseInt(details.productQuantity),
        // rowId: user?.id,
      };
      // console.log(body)
      const response = await axios.post(examCodeUrl, body, {
        headers: { Authorization: `Bearer ${token}` },
      });
      // console.log(response);
      if (response?.data?.status === "success") {
        // console.log(response);
        // console.log("got here");
        // window.history.back();

        dispatch(
          showModal({
            content: (
              <Receipt
                {...response}
                tx_ref={"AYAHSU3484JD93NW0SE"}
                name={details?.payerName}
                examCode={response?.data?.data?.details?.examCode}
                examType={details?.examType}
                price={details?.priceWithCharge}
                email={details?.email}
                noOfCandidates={details?.productQuantity}
              />
            ),
          })
        );
        // navigate('/')
      }
    } catch (err) {
      Swal.fire({
        title: "Error",
        text: `Unable to generate Exam Code. Something went wrong`,
        icon: "error",
        confirmButtonText: "Ok",
      });
    } finally {
      setCodeLoading(false);
    }
  };

  // useEffect(() => {
  //     setTransactionDetailss(details)
  //     console.log(details)
  //     console.log(transactionDetails)
  // }, [])

  useEffect(() => {
    const squad_origin = "https://sandbox-api-d.squadco.com";
    const sandbox_token =
      "sandbox_sk_62cdf2051da496d0e536627233ff0ba816b639102da1";
    const ref = new URLSearchParams(location.search).get("reference");
    const validateRef = async () => {
      const path = `${squad_origin}/transaction/verify/${ref}`;
      try {
        await axios.get(path, { headers: { Authorization: sandbox_token } });
        if (
          details.paymentExamType === "BECE" ||
          details.paymentExamType === "CAS/Placement"
        ) {
          toast.success(`${details.paymentExamType} payment successful`);
          // generateCode();
        } else {
          toast.success(`${details.paymentExamType} payment successful`);
        }
        dispatch(
          showModal({
            content: (
              <ConfirmationReceipt
                //   {...response}
                tx_ref={details?.billNumber}
                name={details?.payerName}
                // examCode={response?.data?.data?.details?.examCode}
                examType={details?.examType}
                price={details?.priceWithCharge}
                // email={user?.email}
                noOfCandidates={details?.productQuantity}
              />
            ),
          })
        );
        {
          details.paymentExamType === "BECE"
            ? navigate("/requisition/bece")
            : details.examType === "CAS/Placement"
            ? navigate("/requisition/junior")
            : details.paymentExamType === "Model/Screening College"
            ? navigate("/requisition/model")
            : navigate("/requisition/public");
        }
      } catch (error) {
        Swal.fire({
          title: "Error",
          text: `Invalid transaction reference`,
          icon: "error",
          confirmButtonText: "Ok",
        });
      }
    };

    if (ref) validateRef();
  }, [location]);

  const invoiceSnapshot = async (id, name) => {
    const image = document.getElementById(id);
    const invoiceUrl = new Image();
    // console.log(invoiceUrl)
    invoiceUrl.src = await domtoimage.toPng(image, { cacheBust: true });
    let downloadLink = document.createElement("a");
    //  console.log(downloadLink)
    downloadLink.href = invoiceUrl.src;
    downloadLink.download = `${name}.png`;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

//   const receiptSnapshot = async (id, name) => {
//     const image = document.getElementById(id);
//     const rcptUrl = new Image();

//     rcptUrl.src = await domtoimage.toPng(image, { cacheBust: true });
//     let downloadLink = document.createElement('a');
//     downloadLink.href = rcptUrl.src;
//     downloadLink.download = `${name}.png`;
//     document.body.appendChild(downloadLink);
//     downloadLink.click();
//     document.body.removeChild(downloadLink);
// }

  function formatDate(date) {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  }

  const today = new Date();
  const formattedDate = formatDate(today);
  const currentTime = new Date().toLocaleTimeString('en-US', { timeZone: 'Africa/Lagos' });

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 16,
    },
  }));
  return (
    <>
      <Box className={styles.invoice_container} style={{position: 'absolute',}}>
        <div id={"invoice-body"} style={{ backgroundColor: "white"}} >
          <Grid container mx={{ xs: 0, md: "auto"}} mb={5} width={{ xs: "100%", md: "80%" }}>
            <Grid mb={{ xs: 3, mb: 1 }} width={"100%"} item>
              <Stack
                px={1}
                spacing={2}
                direction={{ xs: "column", md: "row" }}
                justifyContent={"space-between"}
                alignItems={"center"}
                flex
                flexWrap="wrap"
                width={"100%"}
              >
                <Box bgcolor={""} width={200}>
                  <img
                    src={
                      "/assets/images/laags.png"
                    }
                    alt="Lagos State"
                  />
                </Box>
                <Box bgcolor={""}>
                  <Typography
                    textAlign={"center"}
                    fontWeight={"bolder"}
                    variant="h5"
                  >
                    LAGOS STATE GOVERNMENT
                  </Typography>
                  <Typography
                    textAlign={"center"}
                    fontWeight={"bolder"}
                    variant="h6"
                  >
                    Central Billing System
                  </Typography>
                  <Typography textAlign={"center"} variant="body1">
                    Lagos State Examinations Board
                  </Typography>
                  <Typography
                    textAlign={"center"}
                    fontWeight={"bolder"}
                    variant="body1"
                  >
                    Bill / Demand Notice / Payment Advice
                  </Typography>
                </Box>
                <Box bgcolor={""} border={2} p={2}>
                  <Typography variant="body1" fontWeight={"bolder"}>
                    Lagos State CBS
                  </Typography>
                </Box>
              </Stack>
            </Grid>

            <Grid mb={{ xs: 3, mb: 1 }} xs={12} spacing={2} item>
              <Grid container>
                <Grid
                  item
                  xs={12}
                  md={2}
                  border={2}
                  borderRight={{ xs: 2, md: 0 }}
                  borderBottom={{ xs: 0, md: 2 }}
                  p={1}
                >
                  <Typography variant="body1" fontWeight={"bold"}>
                    Invoice Issued On:
                  </Typography>
                </Grid>

                <Grid
                  item
                  xs={12}
                  md={5}
                  border={2}
                  borderRight={{ xs: 2, md: 0 }}
                  borderBottom={{ xs: 0, md: 2 }}
                  p={1}
                >
                  <Typography variant="body1">
                    LSEB-CBS Integrated Payment Platform
                  </Typography>
                </Grid>

                <Grid
                  item
                  xs={12}
                  md={2}
                  border={2}
                  borderRight={{ xs: 2, md: 0 }}
                  borderBottom={{ xs: 0, md: 2 }}
                  p={1}
                >
                  <Typography variant="body1" fontWeight={"bold"}>
                    Date Printed:
                  </Typography>
                </Grid>

                <Grid item xs={12} md={3} border={2} p={1}>
                  <Typography variant="body1">
                    {formattedDate} {currentTime}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            <Grid xs={12} item>
              <Box>
                <Table sx={{ marginBottom: "0" }}>
                  <TableHead>
                    <TableRow>
                      <StyledTableCell sx={{fontSize: {xs: "9px", md: "13px"}}}>Bill Number</StyledTableCell>
                      <StyledTableCell sx={{fontSize: {xs: "7px", md: "13px"}}}>Customer ID</StyledTableCell>
                      <StyledTableCell sx={{fontSize: {xs: "9px", md: "13px"}}}>Invoice Date</StyledTableCell>
                    </TableRow>
                  </TableHead>
                  <TableRow>
                    <StyledTableCell sx={{fontSize: {xs: "12px", md: "15px"}}}>{downloadDetails.billNumber}</StyledTableCell>
                    <StyledTableCell sx={{fontSize: {xs: "12px", md: "15px"}}}>566848</StyledTableCell>
                    <StyledTableCell sx={{fontSize: {xs:"12px", md:"15px"}}}>{formattedDate} {currentTime}</StyledTableCell>
                  </TableRow>
                </Table>
              </Box>

              <Grid mt={2} container>
                <Grid
                  item
                  xs={12}
                  md={3}
                  border={2}
                  borderRight={{ xs: 2, md: 0 }}
                  borderBottom={{ xs: 0, md: 2 }}
                  p={1}
                >
                  <Typography variant="body1" fontWeight={"bold"}>
                    Payer ID:
                  </Typography>
                </Grid>

                <Grid
                  item
                  xs={12}
                  md={3}
                  border={2}
                  borderRight={{ xs: 2, md: 0 }}
                  borderBottom={{ xs: 0, md: 2 }}
                  p={1}
                >
                  <Typography variant="body1">{details?.payerId}</Typography>
                </Grid>

                <Grid
                  item
                  xs={12}
                  md={3}
                  border={2}
                  borderRight={{ xs: 2, md: 0 }}
                  borderBottom={{ xs: 0, md: 2 }}
                  p={1}
                >
                  <Typography variant="body1" fontWeight={"bold"}>
                    Status:
                  </Typography>
                </Grid>

                <Grid item xs={12} md={3} border={2} p={1}>
                  <Typography variant="body1">Unpaid</Typography>
                </Grid>
              </Grid>
            </Grid>

            <Grid mt={2} xs={12} item>
              <Grid container>
                <Grid
                  item
                  border={2}
                  borderBottom={0}
                  borderRight={{ xs: 2, md: 0 }}
                  xs={12}
                  md={3}
                >
                  <Typography p={1} variant="body1" fontWeight={"bold"}>
                    Customer Name:
                  </Typography>
                </Grid>
                <Grid item border={2} borderBottom={0} xs={12} md={9}>
                  <Typography p={1} variant="body1">
                  {downloadDetails.customerName ? downloadDetails.customerName : downloadDetails.payerInfos[0].firstName + downloadDetails.payerInfos[0].surname}
                  </Typography>
                </Grid>
                <Grid
                  item
                  border={2}
                  borderBottom={{ xs: 0, md: 2 }}
                  borderRight={{ xs: 2, md: 0 }}
                  xs={12}
                  md={3}
                >
                  <Typography p={1} variant="body1" fontWeight={"bold"}>
                    Customer Address:
                  </Typography>
                </Grid>
                <Grid item border={2} xs={12} md={9}>
                  <Typography p={1} variant="body1">
                  {downloadDetails.address}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            <Grid xs={12} item>
              <Box className={styles.payment}>
                <Table >
                  <TableHead>
                    <TableRow>
                      <StyledTableCell sx={{fontSize: {xs: "9px", md: "13px"}}} >Item</StyledTableCell>
                      <StyledTableCell   
                      sx={{fontSize: {xs: "9px", md: "13px"}}}>Description</StyledTableCell>
                      <StyledTableCell sx={{fontSize: {xs: "9px", md: "13px"}}}>Units</StyledTableCell>
                      <StyledTableCell sx={{fontSize: {xs:"9px", md: "13px"}}}>Rate(&#8358;)</StyledTableCell>
                      <StyledTableCell sx={{fontSize: {xs: "9px", md:"13px"},}}>Amount(&#8358;)</StyledTableCell>
                    </TableRow>
                  </TableHead>
                  <TableRow>
                    <StyledTableCell  sx={{fontSize: {xs:"12px", md:"15px"}}}>1</StyledTableCell>
                    <StyledTableCell sx={{fontSize: {xs: "12px", md: "15px"}}}>{schoolName}</StyledTableCell>
                    <StyledTableCell  sx={{fontSize: {xs:"12px", md:"15px"}}}>
                    {downloadDetails.quantity}
                    </StyledTableCell>
                    <StyledTableCell sx={{fontSize: {xs:"12px", md:"15px"}}}>{""}</StyledTableCell >
                    <StyledTableCell  sx={{fontSize: {xs:"12px", md:"15px"}}}>{downloadDetails.amountGenerated}</StyledTableCell>
                  </TableRow>
                </Table>
              </Box>

              <Stack direction={"row"}>
                <Box width={"70%"} p={1} border={2} textAlign={"right"}>
                  <Typography variant="body1" fontWeight={"bold"}>
                    Bill Amount:{" "}
                  </Typography>
                </Box>
                <Box width={"30%"} p={1} border={2} textAlign={"right"}>
                  <Typography variant="body1">
                    {" "}
                    &#8358;{downloadDetails.amountGenerated}
                  </Typography>
                </Box>
              </Stack>

              <Stack
                justifyContent={"center"}
                bgcolor={"black"}
                color={"white"}
                p={1}
                mt={3}
              >
                <Typography textAlign={"center"} variant={"subtitle1"} sx={{fontSize: {xs: "12px", md: "13px"}}}>
                Amount in Words: {downloadDetails.amountGenerated ? toWords.convert(downloadDetails.amountGenerated) : ""} Naira only
                </Typography>
              </Stack>

              <Stack justifyContent={"center"} p={1}>
                <Typography textAlign={"center"} variant={"subtitle1"} >
                  The official Lagos state bill will be collected by the bank
                  you make payment to.
                </Typography>
              </Stack>

              <Stack
                justifyContent={"center"}
                bgcolor={"black"}
                color={"white"}
                p={1}
              >
                <Typography textAlign={"center"} variant={"subtitle1"} sx={{fontSize: {xs: "12px", md: "13px"}}}>
                  Make Payment using your Bill Number: {downloadDetails?.billNumber}
                </Typography>
              </Stack>

              <Stack justifyContent={"center"} p={1}>
                <Typography textAlign={"center"} variant={"subtitle1"}>
                  Total payment due immediately to Lagos State Government.
                </Typography>
                <Typography textAlign={"center"} variant={"subtitle1"}>
                  Part payments are allowed: Subject to confirmation from Lagos
                  State Examinations Board.
                </Typography>
                <Typography textAlign={"center"} variant={"subtitle1"}>
                  [Part Payments may attract multiple transaction charges]
                </Typography>
              </Stack>

              <Stack
                justifyContent={"center"}
                bgcolor={"black"}
                color={"white"}
                p={1}
                mt={3}
              >
                <Typography textAlign={"center"} variant={"subtitle1"} sx={{fontSize: {xs: "12px", md: "13px"}}}>
                  Service charges may be included at the point of payment
                </Typography>
              </Stack>
            </Grid>

            <Grid xs={12} mt={3} item>
              <Grid item>
                <Grid container>
                  <Grid item xs={7} border={2} borderRight={0} borderBottom={0}>
                    <Typography textAlign={"center"} variant="body1">
                      How to Pay
                    </Typography>
                  </Grid>
                  <Grid item xs={5} border={2} borderBottom={0}>
                    <Typography textAlign={"center"} variant="body1">
                      Payment Platform
                    </Typography>
                  </Grid>

                  <Grid
                    p={1}
                    item
                    xs={7}
                    border={2}
                    borderRight={0}
                    borderBottom={0}
                  >
                    <Typography variant="body1">Online Payment</Typography>
                    <Typography variant="body1">
                      1. Visit your preferred Online Payment Platform
                    </Typography>
                    <Typography variant="body1">
                      2. Enter your Bill Number & pay with your ATM card
                    </Typography>
                    <Typography variant="body1">
                      3. Note the Payment Reference/Receipt Number received
                    </Typography>
                  </Grid>
                  <Grid p={1} item xs={5} border={2} borderBottom={0}>
                    <Typography variant="body1">Web</Typography>
                  </Grid>

                  <Grid
                    p={1}
                    item
                    xs={7}
                    border={2}
                    borderRight={0}
                    borderBottom={0}
                  >
                    <Typography variant="body1">Bank Branch</Typography>
                    <Typography variant="body1">
                      1. Make payment at the bank teller
                    </Typography>
                    <Typography variant="body1">
                      2. Receive payment slip/confirmation from the teller
                    </Typography>
                    <Typography variant="body1">
                      3. Check the Lagos state portal for payment confirmation
                    </Typography>
                  </Grid>
                  <Grid p={1} item xs={5} border={2} borderBottom={0}>
                    <Typography variant="body1">Bank Branch</Typography>
                  </Grid>

                  <Grid p={1} item xs={7} border={2} borderRight={0}>
                    <Typography variant="body1">Mobile Payment</Typography>
                    <Typography variant="body1">
                      1. Make payment on your Mobile App using your Bill Number
                    </Typography>
                    <Typography variant="body1">
                      2. Note the Payment Reference/Receipt Number.
                    </Typography>
                  </Grid>
                  <Grid p={1} item xs={5} border={2}>
                    <Typography variant="body1">Mobile</Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Grid xs={12} item>
              <Stack
                justifyContent={"center"}
                bgcolor={"black"}
                color={"white"}
                p={1}
              >
                <Typography textAlign={"center"} variant={"subtitle1"} sx={{fontSize: {xs: "12px", md: "13px"}}}>
                  Please visit https://office.lagosstate.gov.ng/receipt to
                  download your Payment Confirmation & Receipt. Visit the Lagos
                  State Examinations Board Online Portal to print your Payment
                  Confirmation & Receipt. Please ensure you present this Bill.
                </Typography>
              </Stack>

              <Stack justifyContent={"center"} p={1}>
                <Typography
                  textAlign={"center"}
                  fontWeight={"bolder"}
                  variant={"subtitle1"}
                >
                  Contact Details
                </Typography>
              </Stack>

              <Stack justifyContent={"center"} p={1} border={2}>
                <Typography textAlign={"center"} variant={"subtitle1"}>
                  If you have any questions about the Bill, please contact:
                </Typography>
                <Typography textAlign={"center"} variant={"subtitle1"}>
                  Lagos State Examinations Board, Lagos State Secretariat,
                  Alausa, Ikeja, Lagos State
                </Typography>
                <Typography textAlign={"center"} variant={"subtitle1"}>
                  Email: singlebilling@lagosstate.gov.ng
                </Typography>
                <Typography textAlign={"center"} variant={"subtitle1"}>
                  Help Desk Number: 01-2956737, 07045983303, 09090001175
                </Typography>
              </Stack>
            </Grid>
          </Grid>
        </div>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "center",
            gap: "50px",
            marginBottom: "1rem",
          }}
        >
           <div>
            <FormButton
              width="medium"
              label={
                invoiceLoading ? <Spinner width="2%" /> : "Go Back"
              }
              onClick={goBack}
              // onClick={() => {window.scrollTo(0,0);navigate("/")}}
            />
          </div>
          <div>
            <FormButton
              width="medium"
              label={
                invoiceLoading ? <Spinner width="2%" /> : "Download Invoice"
              }
              onClick={() => invoiceSnapshot("invoice-body", `Invoice_${details.paymentExamType}`)}
            />
          </div>
          {/* <div>
            <FormButton
              width="medium"
              label={
                invoiceLoading ? <Spinner width="2%" /> : " Proceed to Payment"
              }
              onClick={() => {
                // dispatch(setdetails(transactionDetails.priceWithCharge = totalAmount ))
                dispatch(showModal({ content: <PaymentModal /> }));
              }}
            />
          </div> */}
        </div>
      </Box>
    </>
  );
};

export default Invoicedownload;
